import { OptionalCustomerReviewRequest } from "../types/CustomerReview";

export const HIGH_RISK_FIELDS: Array<keyof OptionalCustomerReviewRequest> = ["is_pep", "is_sanctioned"];
